.fenaa24 {
  --fenaa20: var(--_12zwosxae);
  --fenaa21: var(--_12zwosxaf);
  --fenaa22: var(--_12zwosxag);
  --fenaa23: var(--_12zwosxah);
}
.fenaa25 {
  --fenaa20: var(--_12zwosxai);
  --fenaa21: var(--_12zwosxaj);
  --fenaa22: var(--_12zwosxak);
  --fenaa23: var(--_12zwosxal);
}
.fenaa26 {
  display: inline;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  font-weight: 400;
  color: var(--fenaa20);
  text-decoration: none;
  border-radius: var(--_12zwosx7o);
  cursor: pointer;
  transition: color 150ms ease;
}
.fenaa26:hover:not([aria-disabled="true"]) {
  color: var(--fenaa21);
}
.fenaa26:active:not([aria-disabled="true"]) {
  color: var(--fenaa22);
}
.fenaa26:focus-visible {
  outline: var(--_12zwosx7r) solid var(--_12zwosx5c);
  outline-offset: 2px;
}
.fenaa26[aria-disabled="true"] {
  color: var(--fenaa23);
  cursor: not-allowed;
}
.fenaa27 {
  text-decoration: underline;
}
.fenaa28 {
  font-size: 1.2em;
  margin-right: var(--_12zwosx7e);
}
.fenaa29 {
  font-size: 1.2em;
  margin-left: var(--_12zwosx7e);
}